var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.75C5.76562 0.75 0.75 5.8125 0.75 12C0.75 18.2344 5.76562 23.25 12 23.25C18.1875 23.25 23.25 18.2344 23.25 12C23.25 5.8125 18.1875 0.75 12 0.75ZM17.3906 9.9375L11.3906 15.9375C11.1562 16.2188 10.8281 16.3125 10.5 16.3125C10.125 16.3125 9.79688 16.2188 9.5625 15.9375L6.5625 12.9375C6.04688 12.4219 6.04688 11.625 6.5625 11.1094C7.07812 10.5938 7.875 10.5938 8.39062 11.1094L10.5 13.1719L15.5625 8.10938C16.0781 7.59375 16.875 7.59375 17.3906 8.10938C17.9062 8.625 17.9062 9.42188 17.3906 9.9375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c4277cc32927471937ef8d6885ff1e99.svg";
export { ForwardRef as ReactComponent };